import React from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button';
import { getDeviceType } from '../../selectors/CMPageSelector';

const CMCouponTargetLink = (props) => {
    const tierItem = get(props, 'contentItem', {});
    const deviceType = useSelector((state) => getDeviceType(state));
    const barCodeData = tierItem.offers.reduce((total, value) => {
        if (value.barCode) {
            total.push(value);
        }
        return total;
    }, []);
    const componentCTABtnStyle = dt([
        tierItem?.redeemingChannel === 'instore' && (barCodeData.length ? '' : 'smOnly:!pt-0'),
        'w-auto',
        'text-base',
        'leading-6',
        'px-2',
        'rounded-lg',
    ]);
    return (
        <div
            className={dt([
                tierItem?.redeemingChannel === 'instore'
                    ? barCodeData.length
                        ? 'smOnly:pt-3'
                        : ''
                    : 'pt-3',
            ])}
        >
            <Button
                className={componentCTABtnStyle}
                aria-label={tierItem?.linkText}
                linkUrl={tierItem?.linkUrl}
                automationId="at-coupon-cta"
                buttonType={deviceType.isMobile ? 'Text' : 'Secondary'}
                size={deviceType.isMobile ? 'Sm' : 'Md'}
                type="button"
            >
                {tierItem?.linkText}
            </Button>
        </div>
    );
};

export default CMCouponTargetLink;
